import ClientOneToOneSessions from './ClientOneToOneSessions';

export default ClientOneToOneSessions;
